import React from 'react'
import { List, Text, Flex } from '@leverege/ui-elements'

export default function RoleItem( props ) {
  const { item, onEvent, ...rest } = props
  const { id, displayName, name, permissions = [] } = item
  let type = 'PROJECT'
  if ( item.projectId === 'imagine' ) {
    type = 'IMAGINE'
  } else if ( item.scope === 'custom' ) {
    type = 'CUSTOM'
  }

  return (
    <List.Item item={item} {...rest} >
      <Flex variant="rowM">
        <Text>{`${displayName || name} ( ${permissions.length} )`}</Text>
        <Text variant="info" style={{ textAlign : 'right', flex : 1 }}>{type}</Text>
      </Flex>
    </List.Item>
  )
}
